import axios from "axios";
import { getToken, clearSession } from "./session";
import { BASE_URL, API_KEY } from "./constants";

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

apiClient.interceptors.request.use((config) => {
  const token = getToken();
  // The gateway treats "apikey" and "Authorization: Bearer" as mutually exclusive —
  // sending apikey short-circuits it into a static-key check and it never looks at
  // the JWT. So once logged in, send only the token; apikey is for pre-login calls.
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (API_KEY) {
    config.headers.apikey = API_KEY;
  }
  // Tracking only — request bodies still send source: "SFA" for backend logic/validation.
  config.headers.api_source = "WEBVIEW";
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only a call that actually carried a session token (Authorization:
    // Bearer) means "your session just died" — force back to login. A 401 on
    // an apikey-only, pre-login call (login, OTP, join-us, forgot-password)
    // is just that request being rejected (e.g. gateway/backend validation),
    // not a session to tear down — let it reject normally so the calling
    // page's own error handling/inline message runs instead of a hard reload
    // wiping it out mid-flight.
    const hadSessionToken = !!error.config?.headers?.Authorization;
    if (hadSessionToken && error.response && error.response.status === 401) {
      clearSession();
      window.location.assign("/");
    }
    return Promise.reject(error);
  }
);

export default apiClient;
